import classNames from 'classnames';
import './progress-bar.scss';

import type { ProgressBarProps } from './types';
import { StepCurrentIcon, StepFinishedIcon, StepPendingIcon } from '../../atoms';

export const ProgressBar = <ID extends string>({ steps, className, onStepClick }: ProgressBarProps<ID>) => (
  <div className={classNames('payflow-ui payflow-progress-bar', className)}>
    {steps.map((step) => (
      <div
        className={classNames('progress-bar__step', step.state === 'current' && 'current')}
        key={step.id}
        onClick={() => {
          if (typeof onStepClick === 'function') {
            onStepClick(step.id);
          }
        }}
      >
        <div className="progress-bar__step-icon">
          {step.state === 'pending' && <StepPendingIcon className="pending" />}
          {step.state === 'visited' && <StepPendingIcon />}
          {step.state === 'current' && <StepCurrentIcon />}
          {step.state === 'finished' && <StepFinishedIcon />}
        </div>
        <div className="progress-bar__step-value">{step.label}</div>
      </div>
    ))}
  </div>
);
